import {useEffect,useRef} from 'react';
/** Isolated WebGL experience, with a cache limited to this event. */
export function UKCWNECPage() {
  const frame=useRef<HTMLIFrameElement>(null),ready=useRef(false);
  const notify=()=>frame.current?.contentWindow?.postMessage({type:'ukcw-offline',ready:ready.current},location.origin);
  useEffect(()=>{
    if(!('serviceWorker' in navigator))return;
    let disposed=false;
    const markReady=()=>{if(!disposed){ready.current=true;notify();}};
    navigator.serviceWorker.register('/ukcw-nec-sw.js',{scope:'/',updateViaCache:'none'}).then(reg=>{
      if(disposed)return;
      if(reg.active?.state==='activated')markReady();
      const observe=()=>{const worker=reg.installing;if(worker)worker.addEventListener('statechange',()=>{if(worker.state==='activated')markReady();});};
      observe();reg.addEventListener('updatefound',observe);
    }).catch(()=>{/* Remain usable online; never claim a failed download is cached. */});
    return()=>{disposed=true;};
  },[]);
  return <iframe ref={frame} onLoad={notify}
    title="NEC UK Construction Week interactive digital twin"
    src="/experiences/nec/2026-09-ukcw/nec-ukcw.html"
    style={{position:'fixed',inset:0,width:'100%',height:'100%',border:0,background:'#122b35'}} allow="fullscreen"/>;
}
